import LanguageToken from '@apps/maha/admin/tokens/language'

const settings = [
  { label: 'Default Language', name: 'language_id', type: 'lookup', endpoint: '/api/admin/lang', valueKey: 'id', textKey: 'text', required: true, format: LanguageToken, defaultValue: 2 },
  { label: 'Default Timezone', name: 'timezone_id', type: 'lookup', endpoint: '/api/admin/timezones', valueKey: 'id', textKey: 'zone', required: true, defaultValue: 172 }
]

export default settings
